export default __webpack_public_path__ + "static/0809-f707801213bab25d2ebc22186ad5e838.jpeg";